import React from 'react'
import _ from 'lodash'

import {Button, Icon, Input} from 'antd'
import {Link} from 'react-router'

import {AuthService} from 'api/auth'

export class Login extends React.Component {
   constructor(p) {
      super(p)

      this.state = {
         email:    '',
         password: '',
         promise:  null,
         loading:  false
      }

      this.updateEmail = this.updateEmail.bind(this)
      this.updatePw = this.updatePw.bind(this)
      this.handleSubmit = this.handleSubmit.bind(this)
   }

   static get propTypes() {
      return {
         // react-router
         router: React.PropTypes.object,

         notify:     React.PropTypes.object,
         redirect:   React.PropTypes.string,
         signupLink: React.PropTypes.object
      }
   }

   componentWillMount() {
      this._mounted = true
   }

   componentWillUnmount() {
      this._mounted = false
      this.setState({password: ''})
   }

   handleSubmit(ev) {
      ev.preventDefault()

      let {email, password} = this.state
      let {notify, router, redirect} = this.props

      if (!email) {
         notify.add(<span> A email is required</span>, 'warning')

         return null
      }

      if (!password) {
         notify.add(<span> Password is required</span>, 'warning')

         return null
      }

      return AuthService.login(email, password)
         .catch(err => {
            this.setState({loading: false})

            switch (_.get(err, 'req.status', -1)) {
               case 400:
               case 401:
                  // login failed!
                  notify.add(
                     <span>Failed to authenticate: {_.get(err, 'data.error', 'unknown')}</span>,
                     'error',
                  )
                  break

               default:
                  notify.add(
                     <span>Failed to authenticate: {_.get(err, 'data.error', 'unknown')}</span>,
                     'error',
                  )
                  break
            }
         })
         .then(([resp, req]) => {
            this.setState({loading: false})

            notify.add(<span>Authenticated! Redirecting to the dashboard</span>, 'success')

            if (!router) {
               console.log('Login: missing router param, can\'t redirect')
            } else if (redirect) {
               router.replace(redirect)
            } else {
               console.log('Login: nothing to redirect to...')
            }
         })
   }

   updateEmail(ev) {
      let email = ev.target.value

      this.setState({email})
   }

   updatePw(ev) {
      let password = ev.target.value

      this.setState({password})
   }

   render() {
      let {loading} = this.state,
         {signupLink} = this.props

      return (
         <form onSubmit={this.handleSubmit} className="form">
            <div className="form-header">
               <h4>Sign In</h4>
            </div>

            <div className="form-input">
               <label htmlFor="login-email">Email address</label>
               <Input
                  type="text"
                  prefix={<Icon type="user" />}
                  onChange={this.updateEmail}
                  placeholder="email@address.com"
               />

            </div>

            <div className="form-input">
               <label htmlFor="login-password">Password</label>
               <Input
                  type="password"
                  prefix={<Icon type="lock" />}
                  onChange={this.updatePw}
                  placeholder="********"
               />
            </div>

            <div className="form-actions">
               {signupLink
                  ? <span className="link signup">
                       <Link to={signupLink}>Don't have an account? Sign up!</Link>
                    </span>
                  : null}

               <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  icon="login"
                  onSubmit={this.handleSubmit}
                  onClick={this.handleSubmit}
               >
                  Sign in
               </Button>
            </div>
         </form>
      )
   }
}



// WEBPACK FOOTER //
// lib/bundle/auth/Login.jsx